const SetterAlertMeasure = (measures, alert, serie) => {
    if (!(alert.type in measures[alert.uuid].alerts.measures)) {
        measures[alert.uuid].alerts.measures[alert.type] = []
    }
    measures[alert.uuid].alerts.measures[alert.type].push(serie);
}

const SetterAlertBattery = (measures, alert, serie) => {
    if (!(alert.type in measures[alert.uuid].alerts.battery)) {
        measures[alert.uuid].alerts.battery[alert.type] = []
    }
    measures[alert.uuid].alerts.battery[alert.type].push(serie);
}

const SetterAlertTemperature = (measures, alert, serie) => {
    if (!(alert.type in measures[alert.uuid].alerts.temperature)) {
        measures[alert.uuid].alerts.temperature[alert.type] = []
    }
    measures[alert.uuid].alerts.temperature[alert.type].push(serie);
}

export const AlertsUtils = {
    keys: {
        sm: SetterAlertMeasure, // Movimiento brusco - AA
        na: SetterAlertMeasure, // No envio de datos
        lb: SetterAlertBattery, // Bateria baja - AB
        ht: SetterAlertTemperature, // Alta temperatura - AC
        ga: SetterAlertMeasure, // Alerta señal GSM -
        pl: SetterAlertMeasure, // Nivel de llenado - AD
        or: SetterAlertMeasure, // Fuera de rango - BA
        fu: SetterAlertMeasure, // Alerta de llenado rapido- BB
        ed: SetterAlertMeasure, // Alerta de vaciado rapido - AF
        re: SetterAlertMeasure, // Alerta de reset - AE
        fi: SetterAlertTemperature, // Alerta de fuego - AC
        ti: SetterAlertMeasure, // Alerta de volcado - BC
        up: SetterAlertMeasure, // Alerta de enderezado - BD
        ul: SetterAlertMeasure, // Descarga detectada
    },
    addAlert: function (measures, alert, serie) {
        if (alert && alert.type in this.keys) {
            this.keys[alert.type](measures, alert, serie);
        } else {
            console.log("[addAlertByType] Alerta no definida:", alert);
        }
    }
}
export default AlertsUtils;